import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { SignOut, Trophy, Fire, Gear } from "@phosphor-icons/react";
import { PRIMARY_NAV, SECONDARY_NAV } from "@/components/header/headerNav";

export function MobileMenuDrawer({ isOpen, onClose, user, logout }) {
  const location = useLocation();
  if (!isOpen) return null;

  const xp = user?.xp || 0;
  const level = user?.level || 1;
  const streak = user?.streak || 0;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 z-40 md:hidden"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.15 }}
            className="fixed left-0 right-0 bottom-[52px] z-40 md:hidden bg-[var(--bg-card)] border-t border-[var(--border-strong)] shadow-xl rounded-t-2xl max-h-[70vh] overflow-y-auto"
          >
            <div className="px-4 py-3 space-y-1">
              {PRIMARY_NAV.length > 4 && (
                <>
                  <p className="text-[10px] font-['JetBrains_Mono'] uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2 px-3">Pages</p>
                  {PRIMARY_NAV.slice(4).map(({ path, label, icon: Icon }) => (
                    <Link
                      key={path}
                      to={path}
                      onClick={onClose}
                      className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors ${
                        location.pathname === path
                          ? "text-[#FF4400] bg-[var(--accent-subtle)]"
                          : "text-[var(--text-secondary)] active:bg-[var(--bg-hover)]"
                      }`}
                      data-testid={`mobile-more-${label.toLowerCase().replace(' ', '-')}`}
                    >
                      <Icon size={20} weight={location.pathname === path ? "fill" : "regular"} />
                      {label}
                    </Link>
                  ))}
                  <div className="border-t border-[var(--border)] my-2" />
                </>
              )}
              <p className="text-[10px] font-['JetBrains_Mono'] uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2 px-3">Builders</p>
              {SECONDARY_NAV.map(({ path, label, icon: Icon }) => (
                <Link
                  key={path}
                  to={path}
                  onClick={onClose}
                  className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === path
                      ? "text-[#FF4400] bg-[var(--accent-subtle)]"
                      : "text-[var(--text-secondary)] active:bg-[var(--bg-hover)]"
                  }`}
                  data-testid={`mobile-more-${label.toLowerCase().replace(' ', '-')}`}
                >
                  <Icon size={20} weight={location.pathname === path ? "fill" : "regular"} />
                  {label}
                </Link>
              ))}

              <div className="border-t border-[var(--border)] my-2 pt-2">
                <Link
                  to="/settings"
                  onClick={onClose}
                  className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname.startsWith("/settings")
                      ? "text-[#FF4400] bg-[var(--accent-subtle)]"
                      : "text-[var(--text-secondary)] active:bg-[var(--bg-hover)]"
                  }`}
                  data-testid="mobile-settings"
                >
                  <Gear size={20} weight={location.pathname.startsWith("/settings") ? "fill" : "regular"} />
                  Settings
                </Link>
              </div>

              <div className="border-t border-[var(--border)] my-2 pt-2">
                <div className="flex items-center justify-between px-3 py-2">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-[var(--badge-pink-subtle)] border border-[var(--badge-pink)]/20">
                      <Trophy size={14} weight="fill" className="text-[var(--badge-pink)]" />
                      <span className="text-xs font-['JetBrains_Mono'] text-[var(--badge-pink)]">LV {level}</span>
                    </div>
                    <span className="text-xs font-['JetBrains_Mono'] text-[var(--success)]">{xp} XP</span>
                    {streak > 0 && (
                      <div className="flex items-center gap-1">
                        <Fire size={14} weight="fill" className="text-[#FF4400]" />
                        <span className="text-xs font-['JetBrains_Mono'] text-[#FF4400]">{streak}</span>
                      </div>
                    )}
                  </div>
                </div>
                <button
                  onClick={() => { logout(); onClose(); }}
                  className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-[var(--text-secondary)] active:bg-[var(--bg-hover)] w-full transition-colors"
                  data-testid="mobile-logout"
                >
                  <SignOut size={20} />
                  Sign Out
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
